import {
  FaClock,
  FaMapMarkerAlt,
  FaDollarSign,
  FaTags,
  FaCalendarAlt,
  FaPhone,
  FaUsers,
  FaEnvelope,
  FaHourglass,
  FaUserCog,
  FaRobot,
  FaChartBar,
  FaBrain,
  FaUserShield,
  FaEye,
  FaHospital,
  FaGlobe,
  FaGraduationCap,
  FaCertificate
} from 'react-icons/fa';

// Function to render the appropriate icon based on the name
export const renderIcon = (iconName) => {

  const lowercaseName = iconName.toLowerCase();

  switch (lowercaseName) {

    /*----- Service Icons -----*/
    case 'robotic automation':
      return <FaRobot />; // Robot icon

    case 'data analytics':
      return <FaChartBar />; // Bar chart icon

    case 'ai application':
      return <FaBrain />; // Brain icon

    case 'security & surveillance':
      return <FaUserShield />; // Shield icon

    case 'computer vision':
      return <FaEye />; // Eye icon

    case 'healthcare solutions':
      return <FaHospital />; // Hospital icon

    /*----- Page Sidebar -----*/
    case 'date':
      return <FaCalendarAlt />; // Calendar icon

    case 'time':
      return <FaClock />; // Clock icon

    case 'duration':
      return <FaHourglass />; // Hourglass icon

    case 'client':
    case 'students':
      return <FaUsers />; // Users icon

    case 'category':
      return <FaTags />; // Tags icon

    case 'location':
      return <FaMapMarkerAlt />; // Map marker icon

    case 'investment':
    case 'fee':
    case 'price':
      return <FaDollarSign />; // Dollar sign icon

    case 'leadengineer':
    case 'organizer':
    case 'instructor':
      return <FaUserCog />; // User with cog icon

    case 'number':
      return <FaPhone />; // Phone icon

    case 'email':
      return <FaEnvelope />; // Envelope icon

    case 'website':
      return <FaGlobe />; // Globe icon

    case 'skilllevel':
      return <FaGraduationCap />; // Graduation cap icon

    case 'certificate':
      return <FaCertificate />; // Certificate icon

    default:
      return null; // No icon matched
  }
};